export class EstadoSistemaSeguridad {
    id: string;
    estado: number;
    fechaHoraUltimoCambio: string;
    responsable: string;
    fechaHoraFS?: string;
    observaciones: string;
    autorizoFS: string;
}